export type TicketStatus =
  | 'open'
  | 'accepted'
  | 'recording'
  | 'processing'
  | 'completed'
  | 'sent'
  | 'cancelled'
  | 'failed'
  | 'pending'
  | 'in_progress';

export function normalizeRole(role?: string): string {
  const r = (role ?? '').trim().toLowerCase();
  if (r === 'video_admin' || r === 'administrator') return 'admin';
  if (r === 'game_master' || r === 'video recorder') return 'video_recorder';
  if (r === 'support' || r === 'customer support') return 'customer_support';
  return r;
}

export function isAdmin(role?: string) {
  return normalizeRole(role) === 'admin';
}

export function isCustomerSupport(role?: string) {
  return normalizeRole(role) === 'customer_support';
}

export function isVideoRecorder(role?: string) {
  return normalizeRole(role) === 'video_recorder';
}

export function isAdminOrSupport(role?: string) {
  return isAdmin(role) || isCustomerSupport(role);
}

export function roleLabel(role?: string): string {
  const r = normalizeRole(role);
  if (r === 'admin') return 'Admin';
  if (r === 'customer_support') return 'Customer Support';
  if (r === 'video_recorder') return 'Video Recorder';
  if (r === 'user') return 'User (legacy)';
  return role ?? '—';
}

/** Roles assignable in User Management (matches Video.Api PortalRoles.Provisionable). */
export const PORTAL_ASSIGNABLE_ROLE_NAMES = [
  'admin',
  'customer_support',
  'video_recorder',
] as const;

export function isPortalAssignableRole(role?: string): boolean {
  return PORTAL_ASSIGNABLE_ROLE_NAMES.includes(
    normalizeRole(role) as (typeof PORTAL_ASSIGNABLE_ROLE_NAMES)[number]
  );
}

export function normalizeStatus(status?: string): TicketStatus {
  const s = (status ?? '').trim().toLowerCase();
  if (s === 'pending') return 'open';
  if (s === 'in_progress') return 'recording';
  return s as TicketStatus;
}

export const STATUS_LABELS: Record<string, string> = {
  open: 'Open',
  accepted: 'Accepted',
  recording: 'Recording',
  processing: 'Processing',
  completed: 'Ready to send',
  sent: 'Sent',
  cancelled: 'Cancelled',
  failed: 'Failed',
  pending: 'Open',
  in_progress: 'Recording',
};
